import { CSSObject, createStyles } from "@mantine/core";
import { BreakpointPxs, pxToEm } from "theme/breakpoints";

interface Params {
  size: BreakpointPxs;
  flex?: CSSObject["flex"];
  contentSpacing?: CSSObject["justifyContent"];
}

export const useStyles = ({ size, contentSpacing, flex, ...styles }: Params) =>
  createStyles(() => ({
    container: {
      ...styles,
      maxWidth: pxToEm[size],
      alignSelf: "center",
      width: "100%",
      display: "flex",
      flex,
      flexDirection: "column",
      justifyContent: contentSpacing,
    },
  }))();
